import React from "react";
import ChatbotWidget from "../components/chatbot/ChatbotWidget";

export default function ChatPage() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f8f8f8", // optional background
      }}
    >
      <ChatbotWidget clinicId="your_clinic_id_here" />
    </div>
  );
}
